module.exports = __webpack_public_path__ + "img/header.2999c19f.png";